module.exports = __webpack_public_path__ + "img/user-04.dee85925.jpg";